(function () {
  const noteHtml = [
    "Administratorem Twoich danych osobowych jest BORCAS Sp. z o.o. Informacje o przetwarzaniu danych osobowych, w szczególności o których mowa w art. 13 ust. 1 i 2 RODO, znajdują się w ",
    '<a href="/policies/privacy-policy" target="_blank" rel="noopener" data-no-instant>Polityce prywatności</a>',
    " oraz ",
    '<a href="//borcas.eu/cdn/shop/t/16/assets/klauzula-informacyjna-borcas.pdf?v=106740652730934136331777469928" target="_blank" rel="noopener" data-no-instant>Klauzuli Informacyjnej</a>.',
  ].join("");

  function attachLegalNote() {
    document.querySelectorAll(".cart-form, .cart-drawer, .cart-order__recap").forEach(function (scope) {
      const checkbox = scope.querySelector(
        "#effectiveAppsAgreeCB, input[id*='effectiveAppsAgree'], input[id*='AgreeCB']"
      );

      if (!checkbox) return;

      const widget =
        checkbox.closest("#effectiveAppsAgreeCBAccountContainer") ||
        checkbox.closest(".rale-widget") ||
        checkbox.closest("label") ||
        checkbox.parentElement;

      if (!widget || widget.dataset.borcasLegalNote === "true") return;

      const note = document.createElement("p");
      note.className = "cart-app-legal-note";
      note.innerHTML = noteHtml;

      widget.insertAdjacentElement("afterend", note);
      widget.dataset.borcasLegalNote = "true";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachLegalNote);
  } else {
    attachLegalNote();
  }

  new MutationObserver(attachLegalNote).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
